import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

const FieldContainer = ({ children, styles, lg = 8, spacing = 2 }) => (
    <Grid container item lg={lg} spacing={spacing} alignItems="center" justify="flex-start" style={styles}>
        {children}
    </Grid>
);

FieldContainer.propTypes = {
    children: PropTypes.node,
    styles: PropTypes.object,
    lg: PropTypes.object,
    spacing: PropTypes.object
};

export { FieldContainer };
